// extracted by mini-css-extract-plugin
export default {"Content":"view_list_Content__ZNnif","List":"view_list_List__QFsEr","InfoSection":"view_list_InfoSection__xY-+R","TeamSection":"view_list_TeamSection__lJpNq"};